import { motion } from 'motion/react';
import { Sparkles, FileText, BarChart3, CheckCircle2 } from 'lucide-react';

export default function FeaturesSection() {
  const features = [
    { icon: Sparkles, title: "AI Assistant", desc: "Summarize reports and explain concepts instantly using state-of-the-art AI." },
    { icon: FileText, title: "Smart Reporting", desc: "Generate professional financial statements with automated data analysis." },
    { icon: BarChart3, title: "Real-time Analytics", desc: "Monitor your financial health with live dashboards and trend forecasting." },
    { icon: CheckCircle2, title: "Compliance Ready", desc: "Stay up to date with the latest accounting standards and tax regulations." }
  ];

  return (
    <section id="features" className="py-24 bg-slate-50 dark:bg-slate-900/50 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-slate-900 dark:text-white mb-4">Built for Modern Finance</h2>
          <p className="text-slate-600 dark:text-slate-400 max-w-xl mx-auto">Powerful tools designed to streamline your accounting workflow and provide deeper insights.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glass-card p-8 hover:shadow-md transition-shadow"
            >
              <div className="bg-primary/10 w-12 h-12 rounded-xl flex items-center justify-center mb-6">
                <feature.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-3">{feature.title}</h3>
              <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">{feature.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
